import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const approvalRequestListService = (
  params: Types.ApprovalRequestListRequest
) =>
  RestAPIClient.call<Types.ApprovalRequestListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const approvalRequestCreateService = (
  params: Types.ApprovalRequestCreateRequest
) =>
  RestAPIClient.call<RestAPIResponseList<Record<string, string>>>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const approvalRequestUpdateService = (
  params: Types.ApprovalRequestUpdateRequest
) =>
  RestAPIClient.call<RestAPIResponseList<Record<string, string>>>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const approvalRequestDetailService = (id: string) =>
  RestAPIClient.call<Types.ApprovalRequest>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const approvalRequestApproveService = (
  params: Types.ApprovalRequestApproveRequest
) =>
  RestAPIClient.call<Types.ApprovalRequest>({
    method: HTTPRequestMethods.POST,
    url: Paths.Approve,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });
